import patch from './patch';
import CalculatorApi from '../../lib/calculator.api';
import s from '../selectors';
import debounce from '../../lib/debounce';
import { computeUserFootprint } from './computeResults';
import { handleUnexpectedError } from './handleUnexpectedError';

/**
 * computeAverageFootprint will merge the new params into state.average_footprint.data.
 * It will then use that update to call the Cool Climate calculator get_defaults_and_results
 * op. Those returned defaults and results are then passed to the compute_footprint op, which
 * is then stored to state.average_footprint.data. Last, the new params are passed to compute
 * the user footprint.
 * @param {Object.<String, String|Number>} params Any subset of input API keys used
 * in op=get_defaults_and_results.
 */
export default params => async (dispatch, getState) => {
  if (params) {
    dispatch(patch({
      average_footprint: {
        calculating: true,
      },
      user_footprint: {
        inputs: params,
      },
    }));
  }

  debounce('computeAverageFootprint', async () => {
    try {
      const state = getState();
      const defaultAndResultsParams = s.params.getDefaultsAndResults(state);
      const defaultsAndResults = await CalculatorApi.getDefaultsAndResults(defaultAndResultsParams);
      if (defaultsAndResults.failed) throw new Error(JSON.stringify(defaultsAndResults));

      const averageUpdate = {
        average_footprint: {
          get_defaults_and_results: defaultsAndResults,
          calculating: false,
        },
      };

      dispatch(patch(averageUpdate));
      await computeUserFootprint({})(dispatch, getState);
    } catch (err) {
      handleUnexpectedError(err)(dispatch, getState);
    }
  });
};
